/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2022-09-03 11:47:17
 * @LastEditTime: 2024-07-30 11:17:58
 */
const state = {
  currentPage: '', // 详情页类型：普通：normal、冷链：coldchain TODO:后续最好换成currentDetailPageType
  currentOrderType: '', // 当前运输单类型：1饲料运输订单、2生猪运输订单、3肥猪送宰订单、4食品冷链订单
  currentDetailPageType: '', // 详情页类型：普通：normal、冷链：coldchain
  transportInfo: {},//运输单详情（签收人-待签收列表跳转签收页使用）
}

const mutations = {
  UPDATE_CURRENT_PAGE: (state, value) => {
    state.currentPage = value
  },
  UPDATE_TRANSPORT_INFO: (state, value) => {
    state.transportInfo = value

  }
}

const actions = {
  updateCurrentPage ({
    commit
  }, data) {
    commit('UPDATE_CURRENT_PAGE', data)
  },
  updateTransport ({
    commit
  }, data) {
    commit('UPDATE_TRANSPORT_INFO', data)

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/transport.js